export default __webpack_public_path__ + "288ee7b12a4d753bd234b67e728cf0ad.png";